<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NOTE')">
        <inputvalidation :formerror="formError" name="note">
          <b-form-input type="text" v-model="formData.note"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'NoteForm',
  props: ['formData', 'formError']
}
</script>
